import React, { useEffect } from 'react';
import MinimalArrow from "../components/MinimalArrow";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import img3 from '../assets/formazione/formazione.jpg';
import formazione from '../assets/logo/formazione.png';
import CallButton from "../components/CallButton";
import ContactForm from "../components/contactForm/ContactForm";


export default function Formazione() {

  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


return <>
  <Navbar />
  <MinimalArrow 
    title={'Formazione'}
    subtitle={'In MCare la formazione ricopre un ruolo fondamentale per poter essere al passo con le nuove scoperte scientifiche e garantire cure sempre migliori e all’avanguardia.'}
    backgroundImage={img3}
  />
    <div className="bg-black">
        <div className="flex flex-col justify-center items-center w-10/12 lg:w-6/12 h-auto mx-auto pt-32">
            <p className="text-left text-white text-3xl font-medium mb-10">
                Per questo motivo, pianifichiamo regolarmente presso la nostra sede diversi corsi di formazione a cui partecipano professionisti nazionali e internazionali.
            </p>
            <p className="text-left text-white text-xl mb-20">
                Collaboriamo inoltre con l’Università di Verona, organizzando lezioni frontali e corsi pratici volti a formare gli studenti del corso di laurea in fisioterapia. Nello specifico, a livello universitario, il nostro focus è sull’insegnamento della chinesiologia e biomeccanica dell’apparato locomotore, oltre alla fisioterapia sportiva, in cui i nostri fisioterapisti sono altamente specializzati.
            </p>
            <img src={formazione} alt="logo formazione" className='bg-contain'/>
        </div>
    </div>
        <div className="col-span-4 flex justify-center items-center py-32 bg-black">
          <div className="w-full absolute z-0" style={{"height":"120%"}}></div>
          <div className='w-full xl:w-3/6 z-40 px-5'>
            <p className='text-center text-4xl font-semibold text-mcare panoragraf-light'>Richiedi Informazioni</p>
            <ContactForm 
              LandingName='MCare formazione'
              Name={true}
              NameClass='text-slate-50'
              NameText='Nome e Cognome:'
              NameRequired={true}
              Tel={true}
              TelClass='text-slate-50'
              TelText='Telefono:'
              TelRequired={true}
              Email={true}
              EmailClass='text-slate-50'
              EmailText='Email:'
              EmailRequired={true}
              ConsensoDati={true}
              ConsensoDatiRequired={true}
              ConsensoDatiText='Consenso dati'
              ConsensoDatiID={1}
              ConsensoDatiClass='text-slate-50'
              successText='Messaggio inviato con successo!'  
              successLink='/'
              errorText='Si è verificato un errore, Riprova!'
              SendText='Invia'
              SendClass='progress-button-mcare w-full '
            />
          </div>
        </div>

  <CallButton />
  <Footer />
</>
}